<template>
  <div>
    <b-tabs>
      <b-tab
        active
        title="Genel"
      >
        <General />
      </b-tab>
      <b-tab
        title="Kariyer"
        lazy
      >
        <Career />
      </b-tab>
      <b-tab
        title="Kişisel Bilgiler"
        lazy
      >
        <Personal />
      </b-tab>
      <b-tab
        title="Diğer Bilgiler"
        lazy
      >
        <Others />
      </b-tab>
      <b-tab
        title="İzin"
        lazy
      >
        <Permits />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import General from './Edit/General'
import Career from './Edit/Career'
import Personal from './Edit/Personal'
import Others from './Edit/Others'
import Permits from './Edit/Permits'

export default {
  name: 'Edit',
  components: {
    BTabs,
    BTab,
    General,
    Career,
    Personal,
    Others,
    Permits,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {

  },
  methods: {

  },
}
</script>
